<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { useAlert } from 'dashboard/composables';

const { uiSettings, updateUISettings } = useUISettings();
const { t: $t } = useI18n();
const pasteOptions = [
  {
    value: 'preserve_all',
    label:
      'PROFILE_SETTINGS.FORM.INTERFACE_SECTION.PASTE_BEHAVIOR.OPTIONS.PRESERVE_ALL.HEADING',
    description:
      'PROFILE_SETTINGS.FORM.INTERFACE_SECTION.PASTE_BEHAVIOR.OPTIONS.PRESERVE_ALL.DESCRIPTION',
  },
  {
    value: 'text_with_links',
    label:
      'PROFILE_SETTINGS.FORM.INTERFACE_SECTION.PASTE_BEHAVIOR.OPTIONS.TEXT_WITH_LINKS.HEADING',
    description:
      'PROFILE_SETTINGS.FORM.INTERFACE_SECTION.PASTE_BEHAVIOR.OPTIONS.TEXT_WITH_LINKS.DESCRIPTION',
  },
  {
    value: 'plain_text_only',
    label:
      'PROFILE_SETTINGS.FORM.INTERFACE_SECTION.PASTE_BEHAVIOR.OPTIONS.PLAIN_TEXT_ONLY.HEADING',
    description:
      'PROFILE_SETTINGS.FORM.INTERFACE_SECTION.PASTE_BEHAVIOR.OPTIONS.PLAIN_TEXT_ONLY.DESCRIPTION',
  },
];

const selectedValue = computed({
  get: () => uiSettings.value.paste_behavior || 'preserve_all',
  set: async value => {
    updateUISettings({ paste_behavior: value });
    useAlert(
      $t(
        'PROFILE_SETTINGS.FORM.INTERFACE_SECTION.PASTE_BEHAVIOR.UPDATE_SUCCESS'
      )
    );
  },
});

const handleChange = value => {
  selectedValue.value = value;
};
</script>

<template>
  <div class="flex flex-col gap-3 w-full">
    <div>
      <label class="text-n-gray-12 font-medium leading-6 text-sm">
        {{ $t('PROFILE_SETTINGS.FORM.INTERFACE_SECTION.PASTE_BEHAVIOR.TITLE') }}
      </label>
      <p class="text-n-gray-11">
        {{ $t('PROFILE_SETTINGS.FORM.INTERFACE_SECTION.PASTE_BEHAVIOR.NOTE') }}
      </p>
    </div>

    <div class="space-y-3 ms-5">
      <div
        v-for="option in pasteOptions"
        :key="option.value"
        class="flex items-start gap-3"
      >
        <div class="flex items-center mt-1">
          <input
            :id="`paste-${option.value}`"
            type="radio"
            name="paste-behavior"
            :value="option.value"
            :checked="selectedValue === option.value"
            class="h-4 w-4 border-gray-300 text-blue-600 focus:ring-blue-500 focus:ring-2 focus:ring-offset-2 disabled:opacity-50"
            @change="handleChange(option.value)"
          />
        </div>
        <div class="min-w-0 flex-1">
          <label
            :for="`paste-${option.value}`"
            class="text-sm font-medium text-n-gray-12 cursor-pointer"
          >
            {{ $t(option.label) }}
          </label>
          <p class="text-sm text-n-gray-11 mt-1">
            {{ $t(option.description) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
input[type='radio'] {
  --tw-ring-color: #3b82f6;
}

input[type='radio']:checked {
  background-color: #3b82f6;
  border-color: #3b82f6;
}

input[type='radio']:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  box-shadow:
    0 0 0 2px #ffffff,
    0 0 0 4px #3b82f6;
}
</style>
